function noticeError(e) {
  // eslint-disable-next-line no-console
  console.error(e);
  let errorToLog = e;
  if (typeof e === "string") {
    errorToLog = new Error(e);
  }

  if (window.newrelic) {
    // Must throw to ensure stack traces in all browsers in all situations
    // https://docs.newrelic.com/docs/browser/new-relic-browser/browser-agent-spa-api/noticeerror-browser-agent-api/#browser-limits
    try {
      throw errorToLog;
    } catch (err) {
      window.newrelic.noticeError(err);
    }
  }
}

function noticeInteraction(id, params) {
  if (window.newrelic) {
    window.newrelic.addPageAction(id, params);
  }
}

function setAttribute(key, val) {
  if (window.newrelic) {
    window.newrelic.setCustomAttribute(key, val);
  }
}

function unsetAttribute(key) {
  if (window.newrelic) {
    window.newrelic.setCustomAttribute(key, undefined);
  }
}

// This somewhat verbose setup is so people import from index, not newrelic specifically.
// The separation will be handy if/when we change our monitoring solution.
const api = {
  noticeError,
  noticeInteraction,
  setAttribute,
  unsetAttribute,
};
export default api;
